import client from './client';

// Fetch all reads or filter by query
export const fetchReads = async (query = {}): Promise<any[]> => {
    try {
        const response = await client.get<any[]>('/reads', { params: query });
        return response.data;
    } catch (error) {
        console.error('Error fetching reads:', error);
        throw error;
    }
};

// Fetch a single read by ID
export const fetchReadById = async (id: string): Promise<any> => {
    try {
        const response = await client.get<any>(`/reads/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching read:', error);
        throw error;
    }
};
// Fetch a single read by ID
export const fetchReadBySlug = async (slug: string): Promise<any> => {
    try {
        const response = await client.get<any>(`/reads/slug/${slug}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching read:', error);
        throw error;
    }
};

// Create a new read
export const postRead = async (payload: any, token: string): Promise<any> => {
    try {
        const response = await client.post<any>('/reads', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating read:', error);
        throw error;
    }
};

// Update an existing read by ID
export const updateRead = async (payload: any, id: string, token: string): Promise<any> => {
    try {
        const response = await client.patch<any>(`/reads/${id}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating read:', error);
        throw error;
    }
};

// Delete a read by ID
export const removeRead = async (id: string, token: string): Promise<any> => {
    try {
        const response = await client.delete<any>(`/reads/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting read:', error);
        throw error;
    }
};

// Update the order of content blocks within a read
export const updateContentOrder = async (payload: any, token: string): Promise<any> => {
    try {
        const response = await client.patch<any>('/reads/order/save', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating content order:', error);
        throw error;
    }
};
